import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  ButtonGroup,
} from 'reactstrap';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';

const CalendarLabels = (props) => {
  const { t, toggle, onSelectCalendar, calendarList, onCheckedCalendar } =
    props;

  const calendarListRender = () =>
    calendarList.map((calendar) => (
      <p className="checkbox-btn" key={calendar.id}>
        <Field
          name={`${calendar.name}-${calendar.id}`}
          component={renderCheckBoxField}
          color={calendar.colorHexa}
          defaultChecked
          className="colored"
          onChange={(event) => {
            if (event.target) {
              onCheckedCalendar(event.target.checked, calendar);
            }
          }}
        />
        <button
          type="button"
          className="calendar-btn d-block overflow-hidden text-nowrap text-ellipsis"
          onClick={() => onSelectCalendar(calendar)}
        >
          {calendar.name}
        </button>
      </p>
    ));

  return (
    <Col md={12} lg={12} xl={3}>
      <Card className="card--not-full-height">
        <CardBody>
          <div className="card__title">
            <h5 className="bold-text">{t('general.calendars')}</h5>
          </div>
          {calendarListRender()}
          <ButtonToolbar>
            <ButtonGroup className="btn-group--justified">
              <Button color="primary" onClick={toggle}>
                {t('general.new-calendar')}
              </Button>
            </ButtonGroup>
          </ButtonToolbar>
        </CardBody>
      </Card>
    </Col>
  );
};

CalendarLabels.propTypes = {
  t: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  onSelectCalendar: PropTypes.func.isRequired,
  calendarList: PropTypes.arrayOf(PropTypes.shape).isRequired,
  onCheckedCalendar: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  reduxForm({
    form: 'CalendarLabels',
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
  })(CalendarLabels)
);
